import { api } from './api';

const getAll = async () => {
  try {
    const { data } = await api.get(`/users/all`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getPaginated = async filters => {
  try {
    const { data } = await api.post(`/users/search`, filters);
    return data;
  } catch (err) {
    console.error(err);
    return { result: [] };
  }
};

const getRoles = async () => {
  try {
    const { data } = await api.get(`/users/roles`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const createUser = async body => {
  try {
    const { data } = await api.post(`/users`, body);
    return data;
  } catch (err) {
    console.error(err);
    throw err;
  }
};
const updateUser = async (id, body) => {
  try {
    const { data } = await api.put(`/users/${id}`, body);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};
const deleteUser = async id => {
  try {
    const { data } = await api.delete(`/users/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const getAdminRights = async () => {
  try {
    const { data } = await api.get(`/adminRights`);
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const createAdminRights = async body => {
  try {
    const { data } = await api.post(`/adminRights`, body);
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const updateAdminRights = async (id, body) => {
  try {
    const { data } = await api.put(`/adminRights/${id}`, body);
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const deleteAdminRights = async id => {
  try {
    const { data } = await api.delete(`/adminRights/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getByMongoId = async id => {
  try {
    const { data } = await api.get(`/users/custom/${id}`);
    return data;
  } catch (err) {
    console.error(err);
    return {};
  }
};

const getUserLogs = async body => {
  try {
    const { data } = await api.post(`/v2/insight/usagetracking/search`, body);
    return data;
  } catch (err) {
    console.error(err);
    return { data: [], total: 0, page: 1, limit: 20, pages: 0 };
  }
};

const getByIds = async ids => {
  try {
    // /!\ attention seul un user ADMIN peu appeler cette route
    const { data } = await api.post(`/users/ids`, { ids });
    return data;
  } catch (err) {
    console.error(err);
    return [];
  }
};

const sendCreationMail = async email => {
  try {
    await api.post(`/users/sendcreationmail`, {
      email
    });
    return true;
  } catch (error) {
    return false;
  }
};

export default {
  getAll,
  getRoles,
  createUser,
  updateUser,
  deleteUser,
  getAdminRights,
  createAdminRights,
  updateAdminRights,
  deleteAdminRights,
  getByMongoId,
  getUserLogs,
  getPaginated,
  getByIds,
  sendCreationMail
};
